<template>
  <div class="approved_box">
    <ax-result-page
      v-if="showResult"
      type="network"
      subtext="要不然下拉刷新试试？"
    ></ax-result-page>
    <div v-if="!showResult && showContent">
      <div class="number">单号：{{ data.工单ID }}</div>
      <ax-head>
        <div slot="ing" v-if="action">
          <p>
            <em>{{ data.申请人 }}</em
            >申请的<em>{{ data.工单名称 }}</em
            >，请您审批！
          </p>
        </div>
        <div slot="over" v-else>
          <p>审批人：{{ data.审批人 }}</p>
          <p>您已审批</p>
        </div>
      </ax-head>
      <ax-panel title="审批单信息">
        <van-cell v-for="(item, key) in data" :key="key" :title="key">
          <b class="content_box" v-html="item"></b>
        </van-cell>
      </ax-panel>
      <div v-if="action">
        <ax-panel title="审批意见" :noBorder="true">
          <textarea
            class="comments_box"
            rows="3"
            v-model="opinion"
            placeholder="请输入您的审批意见"
          ></textarea>
        </ax-panel>
        <div class="handle_box">
          <a class="reject" href="javascript:;" @click="handleApproval(-1)"
            >驳回</a
          >
          <a class="approve" href="javascript:;" @click="handleApproval(1)"
            >同意</a
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { fetchData } from '@/api/hulk';
import doNext from '@/mixins/doNext';

export default {
  name: 'hulkDetails',
  mixins: [doNext],
  data() {
    return {
      id: this.$route.query.id,
      version: this.$route.query.version || 0.0,
      data: {},
      opinion: '',
      showResult: false,
      showContent: false,
      action: false,
      toast: null,
    };
  },
  created() {
    this.toast = this.$toast.loading({
      mask: false,
      message: '加载中...',
      duration: 0,
    });
    this.getDetailsData();
  },
  methods: {
    getDetailsData() {
      fetchData('getDetail', {
        apply_id: this.id,
      })
        .then((response) => {
          this.toast.clear();
          if (response.data.errno === 0) {
            this.data = response.data.data;
            response.data.data.状态 === '待处理'
              ? (this.action = true)
              : (this.action = false);
            this.showContent = true;
          } else {
            this.showResult = true;
          }
        })
        .catch(() => {
          this.toast.clear();
          this.showResult = true;
        });
    },
    handleApproval(item) {
      let name = '',
        operate = '',
        query = {
          apply_id: this.id,
          amemo: this.opinion.replace(
            '/uD83C|uD83D|uD83E[u200D|uFE0F]|uD83C|uD83D|uD83E|[0-9|*|#]uFE0Fu20E3|[0-9|#]u20E3|[u203C-u3299]uFE0Fu200D|[u203C-u3299]uFE0F|[u2122-u2B55]|u303D|[A9|AE]u3030|uA9|uAE|u3030/ig',
            ''
          ),
        },
        data = {
          jumpType: '',
          instId: this.id,
          version: this.version,
          opinion: this.opinion.replace(
            '/uD83C|uD83D|uD83E[u200D|uFE0F]|uD83C|uD83D|uD83E|[0-9|*|#]uFE0Fu20E3|[0-9|#]u20E3|[u203C-u3299]uFE0Fu200D|[u203C-u3299]uFE0F|[u2122-u2B55]|u303D|[A9|AE]u3030|uA9|uAE|u3030/ig',
            ''
          ),
          jsonData: JSON.stringify(query),
        };
      item === 1
        ? ((name = '同意'), (data.jumpType = 'AGREE'),(operate = 'handleDoPass'))
        : ((name = '驳回'), (data.jumpType = 'BACK_TO_STARTOR'),(operate = 'handleDoDeny'));

      this.$dialog
        .confirm({
          title: '提示',
          message: '确定执行' + name + '操作?',
          beforeClose: (action, done) => {
            if (action === 'confirm') {
              this.handleDoNext(data, '审批成功', done);
            } else {
              done();
            }
          },
        })
        .catch(() => {});
    },
  },
  beforeDestroy() {
    this.toast.clear();
  },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
